import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductFiltersModule, ProductModule } from './../../components';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { SearchComponent } from './search.component';
import { NgxMasonryModule } from 'ngx-masonry';

const DECLARATIONS = [SearchComponent];

const MODULES = [CommonModule,   InfiniteScrollModule,ProductModule,ProductFiltersModule,
  NgxMasonryModule
];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...MODULES],
  exports: [...DECLARATIONS, ...MODULES]
})
export class SearchModule {}
